<template>
  <div class="d-flex flex-column gap-2">
    <document-upload-button
      :required="field.required"
      :rules="validationRules"
      :placeholder="field.description"
      :description="field.description"
      :label="field.label"
      @uploaded="v => (field.value = v)"
      multiple
      :appointment-identifier="appointmentIdentifier"
      :warehouse-id="warehouseId"></document-upload-button>
    <p class="typography-body-sm text__color-text-secondary">
      Maximum
      <strong>50MB</strong>
      in size per file. Maximum
      <strong>{{ novaCore.MULTI_DOC_MAX_FILES_PER_APPOINTMENT }}</strong>
      files allowed. Only
      <strong>image</strong>
      ,
      <strong>text</strong>
      ,
      <strong>zip</strong>
      or
      <strong>spreadsheet</strong>
      allowed.
    </p>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/components/custom_fields/mixins/customFieldTypeMixin';

export default {
  mixins: [customFieldTypeMixin],
  props: {
    appointmentIdentifier: {
      type: String,
      required: false
    },
    warehouseId: {
      type: String,
      required: true
    }
  }
};
</script>
